import { motion } from "framer-motion";
import Section, { SectionHeading } from "@/components/Section";

const STEPS = [
  { title: "Launch Readiness", text: "Store manpower plan, role mapping, onboarding, documentation and training." },
  { title: "Team Deployment", text: "Pickers, packers, supervisors, managers, housekeeping, security and support teams." },
  { title: "SOP Execution", text: "Picking, packing, dispatch, attendance, hygiene, compliance and escalation workflows." },
  { title: "Performance Monitoring", text: "Daily MIS, SLA tracking, attendance reports, productivity insights and issue resolution." },
  { title: "Scale Replication", text: "Repeatable playbook for new stores, new cities and multi-location operations." },
];

export default function OperatingFramework() {
  return (
    <Section id="framework" bg="white">
      <SectionHeading
        eyebrow="Operating Framework"
        title={<>A repeatable playbook for <span className="text-[#99CC00]">store-by-store scale.</span></>}
        sub="A clean, operational handover from launch to scale — designed for QC platforms and brands that demand discipline."
      />

      <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-5">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            data-testid={`framework-step-${i}`}
            className="rounded-[1.7rem] border border-neutral-200 bg-white p-6 lg:p-7 shadow-sm hover:-translate-y-1 hover:shadow-xl hover:border-[#99CC00]/40 transition"
          >
            <div
              className="mb-8 flex h-12 w-12 items-center justify-center rounded-full text-xl font-display font-black text-[#1F1F1F]"
              style={{ background: "#99CC00" }}
            >
              {i + 1}
            </div>
            <h3 className="text-xl lg:text-2xl font-display font-black tracking-tight">{s.title}</h3>
            <p className="mt-4 text-sm leading-6 text-neutral-600">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
